(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ContactsFacility', ContactsFacility);

    ContactsFacility.$inject = ['$resource'];

    function ContactsFacility ($resource) {
        var resourceUrl =  'api/contacts-facilities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {'url': 'api/contacts-facilities/filter', method: 'GET', isArray: true},
        });
    }
})();
